var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"column-button-group"},_vm._l((_vm.rows),function(row,rowIdx){return _c('v-row',{staticClass:"button-group-row"},_vm._l((row),function(button,itemIdx){return _c('v-col',{key:button.id,staticClass:"button-item",class:{
          'selected': button.id === _vm.selected,
          'top': rowIdx === 0,
          'left': itemIdx === 0,
          'bottom': rowIdx === _vm.rows.length - 1,
          'right': itemIdx === row.length - 1,
          'disabled': button.disabled
          },attrs:{"cols":Math.floor(12/_vm.cols)},on:{"click":function($event){return _vm.onSelected(button.id)}}},[_vm._v(" "+_vm._s(button.label)+" ")])}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }